import React from "react"
import {
  withStyles,
  WithStyles,
  createStyles,
  Typography,
  Theme,
} from "@material-ui/core"

import { useGlobalLanguageText } from "../../../../../utils/language"

const styles = ({ breakpoints: { up } }: Theme) => {
  const upMd = up("md")
  return createStyles({
    root: {
      fontSize: "2rem",
      fontWeight: 300,
      lineHeight: "2.9375rem",
      marginBottom: "2.1875rem",
      textAlign: "center",
    },
  })
}

interface Props extends WithStyles<typeof styles> {}

const Description = ({ classes }: Props) => {
  const {
    footer: { description },
  } = useGlobalLanguageText()
  return <Typography className={classes.root}>{description}</Typography>
}

export default withStyles(styles)(Description)
